import React, { useState, useEffect, useContext } from 'react';
// import {
//   FiUser, FiCheckCircle, FiClock, FiSearch,
//   FiChevronLeft, FiChevronRight, FiStar,
//   FiMail, FiPhone, FiCalendar, FiTrendingUp, FiAlertCircle, FiHome
// } from 'react-icons/fi';
import {
  FiUser, FiCheckCircle, FiClock, FiSearch,
  FiChevronLeft, FiChevronRight, FiStar,
  FiMail, FiPhone, FiCalendar, FiTrendingUp,
  FiAlertCircle, FiHome, FiPauseCircle, FiPlayCircle,
  FiSlash
} from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import '../../../assets/css/admin/dashboard/adminsellers/allsellers.css';
import AdminMasterLayout from 'layouts/AdminMasterLayout';
import axios from 'axios';
import AppContext from 'context/AppContext';
import Swal from 'sweetalert2';

// ─── Shared seller data (export so SellerProperties can use it) ─
// export const ALL_SELLERS_DATA = [
//   {
//     id: 1, name: 'Olivia Rhye', sellerId: '#3324', email: 'olivia@email.com', phone: '(321) 555-0123',
//     avatar: 'https://i.pravatar.cc/150?img=1',
//     totalProperties: 26, rentProperties: 14, soldProperties: 58, rating: 5,
//     status: 'Verified', statusColor: '#d1fae5', statusTextColor: '#065f46',
//     joinDate: 'June 22, 2022', sales: 71.9, promotions: 58, disputes: 1,
//     properties: [
//       { id: 101, title: 'Modern Glass Villa',  size: '2,500 sqft', address: 'DHA Phase 5, Lahore',      price: 23902, listingType: 'rent', propStatus: 'Active',   bedrooms: 4, bathrooms: 3, parking: 2, yearBuilt: 2020, type: 'Villa',      description: 'Beautiful modern villa with spacious rooms and large garden.', features: ['Swimming Pool','Garden','Garage','Security System','Central Heating'], img: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=600' },
//       { id: 102, title: 'Qalhan Residence',    size: '1,800 sqft', address: 'F-7, Islamabad',            price: 45000, listingType: 'sell', propStatus: 'Sold',    bedrooms: 3, bathrooms: 2, parking: 1, yearBuilt: 2021, type: 'Apartment', description: 'Luxury apartment with panoramic city views and premium finishes.', features: ['Gym','Swimming Pool','Concierge','24/7 Security','Elevator'], img: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=600' },
//       { id: 103, title: 'Gulshan Villa',       size: '3,200 sqft', address: 'Gulshan-e-Iqbal, Karachi',  price: 18500, listingType: 'rent', propStatus: 'Active',   bedrooms: 5, bathrooms: 4, parking: 3, yearBuilt: 2019, type: 'Villa',      description: 'Spacious villa with elegant interiors and private garden.', features: ['Private Garden','Servant Quarter','Study Room','Terrace'], img: 'https://images.unsplash.com/photo-1613977257363-707ba9348227?w=600' },
//       { id: 104, title: 'DHA Phase-6 House',   size: '2,800 sqft', address: 'DHA Phase 6, Karachi',      price: 85000, listingType: 'sell', propStatus: 'Active',   bedrooms: 4, bathrooms: 3, parking: 2, yearBuilt: 2022, type: 'House',     description: 'Brand new house in prime DHA location.', features: ['Solar Panels','Smart Home','CCTV','Generator'], img: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=600' },
//     ],
//   },
//   {
//     id: 2, name: 'Phoenix Baker', sellerId: '#5678', email: 'phoenix@email.com', phone: '(321) 555-7890',
//     avatar: 'https://i.pravatar.cc/150?img=2',
//     totalProperties: 33, rentProperties: 20, soldProperties: 34, rating: 4,
//     status: 'Verified', statusColor: '#d1fae5', statusTextColor: '#065f46',
//     joinDate: 'Mar 15, 2023', sales: 45.2, promotions: 42, disputes: 0,
//     properties: [
//       { id: 201, title: 'Bahria Residence',    size: '2,200 sqft', address: 'Bahria Town, Lahore',       price: 22000, listingType: 'rent', propStatus: 'Active',  bedrooms: 3, bathrooms: 2, parking: 2, yearBuilt: 2021, type: 'House',     description: 'Comfortable home in gated community with all amenities.', features: ['Community Park','Security','School Access','Shopping Mall'], img: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600' },
//       { id: 202, title: 'Commercial Plaza',    size: '5,000 sqft', address: 'Main Boulevard, Karachi',   price: 120000, listingType: 'sell', propStatus: 'Active', bedrooms: 0, bathrooms: 4, parking: 10, yearBuilt: 2023, type: 'Commercial', description: 'Modern commercial plaza in prime location.', features: ['Elevators','Parking','Security','CCTV','Generator'], img: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600' },
//     ],
//   },
//   { id: 3, name: 'Robert Fox',      sellerId: '#9012', email: 'robert@email.com',    phone: '(321) 308-9079', avatar: 'https://i.pravatar.cc/150?img=3',  totalProperties: 21, rentProperties: 8,  soldProperties: 28, rating: 4, status: 'Verified', statusColor: '#d1fae5', statusTextColor: '#065f46', joinDate: 'Jan 10, 2023', sales: 38.5, promotions: 35, disputes: 2, properties: [] },
//   { id: 4, name: 'Henry Fisher',    sellerId: '#3456', email: 'henry@email.com',     phone: '(321) 456-8890', avatar: 'https://i.pravatar.cc/150?img=4',  totalProperties: 7,  rentProperties: 4,  soldProperties: 17, rating: 5, status: 'Verified', statusColor: '#d1fae5', statusTextColor: '#065f46', joinDate: 'Sep 5, 2022',  sales: 28.3, promotions: 25, disputes: 0, properties: [] },
//   { id: 5, name: 'James Ford',      sellerId: '#7890', email: 'james@email.com',     phone: '(321) 908-9079', avatar: 'https://i.pravatar.cc/150?img=5',  totalProperties: 5,  rentProperties: 3,  soldProperties: 3,  rating: 3, status: 'Pending',  statusColor: '#fed7aa', statusTextColor: '#92400e', joinDate: 'Dec 20, 2023', sales: 12.5, promotions: 10, disputes: 1, properties: [] },
//   { id: 6, name: 'Benjamin Crawford',sellerId: '#1234', email: 'benjamin@email.com', phone: '(321) 456-9382', avatar: 'https://i.pravatar.cc/150?img=6', totalProperties: 6,  rentProperties: 2,  soldProperties: 6,  rating: 4, status: 'Blocked',  statusColor: '#fee2e2', statusTextColor: '#991b1b', joinDate: 'Nov 18, 2022', sales: 15.8, promotions: 12, disputes: 5, properties: [] },
//   { id: 7, name: 'George Murphy',   sellerId: '#5555', email: 'george@email.com',    phone: '(321) 894-9821', avatar: 'https://i.pravatar.cc/150?img=7',  totalProperties: 5,  rentProperties: 5,  soldProperties: 0,  rating: 5, status: 'Blocked',  statusColor: '#fee2e2', statusTextColor: '#991b1b', joinDate: 'Aug 12, 2023', sales: 8.2,  promotions: 5,  disputes: 3, properties: [] },
//   { id: 8, name: 'Anusha Ross',     sellerId: '#6789', email: 'anusha@email.com',    phone: '(321) 908-9821', avatar: 'https://i.pravatar.cc/150?img=8',  totalProperties: 9,  rentProperties: 6,  soldProperties: 0,  rating: 5, status: 'Verified', statusColor: '#d1fae5', statusTextColor: '#065f46', joinDate: 'Jul 8, 2023',  sales: 22.4, promotions: 18, disputes: 0, properties: [] },
//   { id: 9, name: 'Sarah Johnson',   sellerId: '#4421', email: 'sarah@email.com',     phone: '(321) 555-1234', avatar: 'https://i.pravatar.cc/150?img=10', totalProperties: 15, rentProperties: 9,  soldProperties: 12, rating: 5, status: 'Verified', statusColor: '#d1fae5', statusTextColor: '#065f46', joinDate: 'Feb 14, 2023', sales: 32.7, promotions: 28, disputes: 0, properties: [] },
//   { id:10, name: 'Mike Wilson',     sellerId: '#7788', email: 'mike@email.com',      phone: '(321) 555-5678', avatar: 'https://i.pravatar.cc/150?img=11', totalProperties: 8,  rentProperties: 3,  soldProperties: 5,  rating: 3, status: 'Pending',  statusColor: '#fed7aa', statusTextColor: '#92400e', joinDate: 'Jan 5, 2024',  sales: 18.9, promotions: 15, disputes: 2, properties: [] },
// ];

// const STATS = [
//   { id: 1, title: 'Sellers',          value: '7,621', change: '+1.2%', Icon: FiUser        },
//   { id: 2, title: 'Verified Sellers', value: '5,283', change: '+1.7%', Icon: FiCheckCircle },
//   { id: 3, title: 'Pending Sellers',  value: '1,135', change: '+0.3%', Icon: FiClock       },
//   { id: 4, title: 'Blocked Sellers',  value: '203',   change: '-2.1%', Icon: FiUser        },
// ];

const AllSellers = () => {
  const navigate = useNavigate();
  const [animateCards, setAnimateCards] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatus, setStatus] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedSeller, setSelected] = useState(null);
  const { baseUrl, authToken, baseUrlForFiles } = useContext(AppContext);
  const [sellers, setSellers] = useState([]);
  // const [status, setStatus] = useState([]);
  const [totalsellers, setTotalSellers] = useState("");
  const [pendingSellers, setPendingSellers] = useState("");
  const [verifiedSellers, setVerifiedSellers] = useState("");
  const [blockedSellers, setBlockedSellers] = useState("");
  const [loading, setLoading] = useState(true);
  const rowsPerPage = 10;


  const statsData = [
    {
      id: 1,
      title: 'Sellers',
      value: totalsellers,
      Icon: FiUser,
    },
    {
      id: 2,
      title: 'Verified Sellers',
      value: verifiedSellers,
      Icon: FiCheckCircle,
    },
    {
      id: 3,
      title: 'Pending Sellers',
      value: pendingSellers,
      Icon: FiClock,
    },
    {
      id: 4,
      title: 'Blocked Sellers',
      value: blockedSellers,
      Icon: FiUser,
    },
  ];
  useEffect(() => {
    setAnimateCards(true);
    setSelected(sellers[0]);
  }, []);

  // const renderStars = (r) => Array(5).fill(0).map((_, i) => (
  //   <FiStar key={i} size={13} fill={i < r ? '#fbbf24' : 'none'} color={i < r ? '#fbbf24' : '#d1d5db'} />
  // ));

  const filtered = (sellers || []).filter((s) => {
    const q = searchTerm?.toLowerCase();
    const matchQ = !q || `${s.firstName} ${s.lastName} `.toLowerCase().includes(q) || s.email?.toLowerCase().includes(q) || s.sellerId?.toLowerCase().includes(q);
    const matchS = selectedStatus === 'all' || s.status?.toLowerCase() === selectedStatus;
    return matchQ && matchS;
  });

  const totalPages = Math.ceil(filtered.length / rowsPerPage);
  const currentData = filtered.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  const goToProperties = (e, seller) => {
    e.stopPropagation();
    navigate(`/admin/allsellers/${seller.id}`, { state: { seller } });
  };

  // const handleStatus = (action, seller) => {
  //   if (action === 'verify') alert(`✅ ${seller.name} verified successfully!`);
  //   if (action === 'suspend') { if (window.confirm(`Suspend ${seller.name}?`)) alert('Seller suspended.'); }
  //   if (action === 'warn') alert(`⚠️ Warning sent to ${seller.name}`);
  //   if (action === 'remove') { if (window.confirm(`Remove all properties of ${seller.name}?`)) alert('Properties removed.'); }
  // };

  const viewAllSellers = () => {
    setLoading(true);
    axios.get(`${baseUrl}/admin/sellers/viewAllSellers`, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": `Bearer ${authToken}`
      }
    })
      .then((response) => {
        console.log(response.data);
        setSellers(response.data.sellers);
        setTotalSellers(response.data.sellers?.length);
        setPendingSellers(response.data.totalpending);
        setVerifiedSellers(response.data.totalverified);
        setBlockedSellers(response.data.totalblocked);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      })
  };

  useEffect(() => {
    viewAllSellers();
  }, []);

  const handleStatus = (action, seller) => {
    const newStatus = action === 'suspend' ? 'blocked' : 'verified';
    const actionText = action === 'suspend' ? 'Suspend' : 'Activate';
    Swal.fire({
      title: `Are you sure?`,
      text: `You want to ${actionText.toLowerCase()} ${seller.firstName} ${seller.lastName}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Yes, ${actionText}`,
      cancelButtonText: 'Cancel',
      confirmButtonColor: action === 'suspend' ? '#dc2626' : '#16a34a',
      cancelButtonColor: '#6b7280',
    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(
          `${baseUrl}/admin/sellers/updateSellerStatus`,
          {
            id: seller.id,
            status: newStatus
          },
          {
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${authToken}`
            }
          }
        )
          .then((response) => {
            if (response.data.success) {
              // Update seller in table
              setSellers(prev =>
                prev.map(item =>
                  item.id === seller.id
                    ? { ...item, status: newStatus }
                    : item
                )
              );
              // Success SweetAlert
              Swal.fire({
                title: 'Success!',
                text: `Seller ${seller.firstName} ${seller.lastName} ${actionText.toLowerCase()}d successfully.`,
                icon: 'success',
                confirmButtonColor: '#000',
                timer: 2000,
                showConfirmButton: false
              });
              // Refresh stats
              viewAllSellers();
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };



  return (
    <AdminMasterLayout pageTitle='All Sellers'>
      <div className="sll-page">

        {/* ── Header ── */}
        {/* <div className="sll-header">
          <div>
            <h1 className="sll-title">All Sellers</h1>
            <p className="sll-subtitle">Monitor all historical activity on the platform</p>
          </div>
        </div> */}

        {/* ── Stats ── */}
        <div className="sll-stats-grid">
          {statsData.map((s, i) => (
            <div key={s.id} className={`sll-stat-card ${animateCards ? 'sll-stat-card--visible' : ''}`}
              style={{ animationDelay: `${i * 0.1}s` }}>
              <div className="sll-stat-icon"><s.Icon size={20} /></div>
              <div className="sll-stat-body">
                <p className="sll-stat-label">{s.title}</p>
                <p className="sll-stat-value">{s.value}</p>
                {/* <span className="sll-stat-change">{s.change}</span> */}
              </div>
            </div>
          ))}
        </div>

        {/* ── Main Layout ── */}
        <div className={`sll-layout ${selectedSeller ? 'sll-layout--split' : ''}`}>

          {/* Table Column */}
          <div className="sll-table-col">

            {/* Controls */}
            <div className="sll-controls">
              <div className="sll-search-wrap">
                <FiSearch className="sll-search-icon" />
                <input className="sll-search-input" placeholder="Search sellers…"
                  value={searchTerm} onChange={e => { setSearchTerm(e.target.value); setCurrentPage(1); }} />
              </div>
              {/* <select className="sll-select" value={selectedStatus}
                onChange={e => { setStatus(e.target.value); setCurrentPage(1); }}>
                <option value="all">All Status</option>
                <option value="verified">Verified</option>
                <option value="pending">Pending</option>
                <option value="blocked">Blocked</option>
              </select> */}
            </div>

            {/* Table */}
            <div className="sll-table-card">
              <div className="sll-table-wrap">
                <table className="sll-table">
                  <thead>
                    <tr>
                      <th>Seller</th>
                      <th>Contact</th>
                      <th>Rent Props</th>
                      <th>Total Props</th>
                      <th>Sold</th>
                      <th style={{ textAlign: 'center' }}>Actions</th>

                    </tr>
                  </thead>
                  <tbody>
                    {/* LOADING */}
                    {loading ? (
                      <tr>
                        <td colSpan="7" className="sll-empty">
                          <div className="sll-loader"></div>
                          <p>Loading sellers...</p>
                        </td>
                      </tr>
                    ) : currentData.length === 0 ? (
                      <tr><td colSpan="7" className="sll-empty">
                        <FiAlertCircle size={36} /><p>No sellers found</p>
                      </td></tr>
                    ) : (currentData.map((s, idx) => (
                      <tr key={s.id}
                        className={`sll-row ${selectedSeller?.id === s.id ? 'sll-row--active' : ''}`}
                        style={{ animationDelay: `${idx * 0.05}s` }}
                        onClick={() => setSelected(prev => prev?.id === s.id ? null : s)}>
                        <td>
                          <div className="sll-user-cell">
                            <img
                              src={`${baseUrlForFiles}${s?.profileImage}`}
                              alt={s?.firstName}
                              className="kyc-modal__avatar"
                            />
                            <div>
                              <h3 className="kyc-modal__name">{s?.firstName} {s?.lastName}</h3>
                              <p className="kyc-modal__email">{s?.email}</p>
                            </div>
                          </div>
                        </td>
                        <td>
                          <p className="sll-email">{s.email}</p>
                          {/* <p className="sll-phone">{s.phone}</p> */}
                        </td>
                        <td className="sll-count">{s.exproperties?.filter(p => p.listing_type === 'rent').length}</td>
                        <td>
                          <button className="sll-rent-btn" onClick={e => goToProperties(e, s)}>
                            <FiHome size={12} /> {s.exproperties?.length}
                          </button>
                        </td>
                        <td className="sll-count">{s.exproperties?.filter(p => p.listing_type === 'sell').length}</td>
                        {/* <td><div className="sll-stars">{renderStars(s.rating)}</div></td> */}
                        {/* ✅ Actions — circle buttons with color change */}
                        {/* <td>
                    <div className="vr-actions">

                      {/* Accept button 
                      <button
                        className={`vr-action-btn vr-btn-accept ${req.status === 'accepted' ? 'vr-btn-accept--done' : ''}`}
                        onClick={() => req.status === 'pending' && handleAccept(req.id)}
                        title="Mark as Accepted"
                        disabled={req.status !== 'pending'}
                      >
                        <CheckCircle size={22} strokeWidth={2} />
                      </button>

                      {/* Reject button 
                      <button
                        className={`vr-action-btn vr-btn-reject ${req.status === 'rejected' ? 'vr-btn-reject--done' : ''}`}
                        onClick={() => req.status === 'pending' && handleReject(req.id)}
                        title="Mark as Rejected"
                        disabled={req.status !== 'pending'}
                      >
                        <XCircle size={22} strokeWidth={2} />
                      </button>

                    </div>
                  </td> */}
                        <td>
                          <div className="vr-actions">

                            {s.status?.toLowerCase() === 'blocked' ? (

                              // ─── Active Button ───
                              <button
                                className="vr-action-btn"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleStatus('active', s);
                                }}
                                title="Activate Seller"
                              >
                                <FiCheckCircle
                                  size={21}
                                  color="#16a34a"
                                  strokeWidth={2}
                                />
                              </button>

                            ) : (

                              // ─── Suspend Button ───
                              <button
                                className="vr-action-btn"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleStatus('suspend', s);
                                }}
                                title="Suspend Seller"
                              >
                                <FiSlash
                                  size={21}
                                  color="#dc2626"
                                  strokeWidth={2}
                                />
                              </button>

                            )}

                          </div>
                        </td>
                      </tr>
                    ))
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="sll-pagination">
                <span className="sll-pagination-info">
                  Showing {currentData.length} of {filtered.length} sellers
                </span>
                <div className="sll-pagination-controls">
                  <button className="sll-page-btn" disabled={currentPage === 1}
                    onClick={() => setCurrentPage(p => p - 1)}><FiChevronLeft size={15} /></button>
                  {/* {Array.from({ length: totalPages }, (_, i) => (
                    <button key={i}
                      className={`sll-page-num ${currentPage === i + 1 ? 'sll-page-num--active' : ''}`}
                      onClick={() => setCurrentPage(i + 1)}>{i + 1}</button>
                  ))} */}
                  {/* <button className="sll-page-btn" disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage(p => p + 1)}><FiChevronRight size={15} /></button> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminMasterLayout>
  );
};

export default AllSellers;